export const filter = (
  value: string,
  search: string | undefined,
  keywords: string[]
) => {
  if (keywords.includes('always show')) {
    return 0.1
  }

  const normalized = (search || '').trim()
  if (!normalized) {
    // When nothing is searched, treat as match to allow default items to render
    return 1
  }

  const tokens = normalized.split(' ')
  const matchesValue = tokens.every((token) =>
    value.toLowerCase().includes(token.toLowerCase())
  )
  const matchesKeywords = tokens.every((token) =>
    keywords.some((keyword) =>
      keyword.toLowerCase().includes(token.toLowerCase())
    )
  )
  return matchesValue || matchesKeywords ? 1 : 0
}
